import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    toast.success("Tümü okundu");
    load();
  };

  const readOne = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  return (
    <div className="p-6 md:p-10 space-y-6 max-w-3xl">
      <header className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-mono text-rose-500 tracking-widest mb-2">// INBOX</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight">Bildirimler</h1>
          <p className="text-zinc-500 mt-2">Ekipten gelen tüm uyarılar burada.</p>
        </div>
        <Button onClick={readAll} data-testid="read-all-button" variant="outline" className="border-zinc-800">
          <CheckCheck className="w-4 h-4 mr-2" /> Tümünü Okundu İşaretle
        </Button>
      </header>

      <div className="space-y-2">
        {items.length === 0 && (
          <Card className="bg-zinc-950 border-zinc-900 p-10 text-center">
            <Bell className="w-10 h-10 mx-auto text-zinc-700 mb-3" />
            <p className="text-zinc-500 text-sm">Bildirim yok.</p>
          </Card>
        )}
        {items.map(n => (
          <Card key={n.id} onClick={()=>!n.read && readOne(n.id)} data-testid={`notification-${n.id}`}
            className={`bg-zinc-950 border-zinc-900 p-4 cursor-pointer transition-colors hover:border-zinc-800
              ${!n.read ? "border-l-4 border-l-rose-500" : "opacity-70"}`}>
            <div className="flex items-baseline justify-between gap-2 mb-1">
              <div className="font-semibold">{n.title}</div>
              <div className="text-[10px] font-mono text-zinc-500">{new Date(n.created_at).toLocaleString("tr-TR")}</div>
            </div>
            <p className="text-sm text-zinc-400">{n.body}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
